import { requestApi } from "./axiosHelper";

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1";

const resourceEP = rootUrl + "/free-resources";

const freeResourceApi = {
  fetchAllResources: async () => {
    try {
      const axiosData = {
        url: resourceEP,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message };
    }
  },

  getAResource: async (id) => {
    try {
      const axiosData = {
        url: `${resourceEP}/${id}`,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message };
    }
  },

  createAResource: async (formObj) => {
    try {
      console.log("API createAResource calling with:", formObj);
      const axiosData = {
        url: `${resourceEP}/create`,
        method: "post",
        data: formObj,
      };
      const data = await requestApi(axiosData, true);
      console.log("API createAResource response:", data);
      return data;
    } catch (error) {
      console.error("API createAResource error:", error);
      return error.response?.data || { status: "error", message: error.message };
    }
  },

  editAResource: async (id, update) => {
    try {
      const axiosData = {
        url: `${resourceEP}/edit/${id}`,
        method: "patch",
        data: update,
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message };
    }
  },

  deleteAResource: async (id) => {
    try {
      const axiosData = {
        url: `${resourceEP}/${id}`,
        method: "delete",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message };
    }
  },
};

export default freeResourceApi;
